import { _ as _extends } from '../../_rollupPluginBabelHelpers-c245b26a.js';
import { forwardRef } from 'react';
import { themed } from '@indeed/ifl-css';
import { useDialogContext } from './context.js';
import { jsx } from '@emotion/react';
import '@indeed/ihl-use-id';
import '../../hooks/useControllableState.js';
import '../../utils/warn.js';
import '../../hooks/useIsMobile.js';
import '../../hooks/useWindowSize.js';
import '../../hooks/useIsomorphicLayoutEffect.js';
import '../../hooks/useResponsiveValue.js';
import '../../hooks/useBreakpointIndex.js';

const baseStyles = _ref => {
  let {
    type
  } = _ref;
  return {
    borderTopWidth: type === "popup" ? 0 : "1px",
    borderTopStyle: "solid",
    borderColor: "border.weak",
    boxSizing: "border-box",
    flexBasis: "auto",
    flexGrow: 1,
    flexShrink: 1,
    fontFamily: "default",
    inlineSize: "100%",
    overflowY: "auto",
    paddingBlockEnd: type === "popup" ? 4 : ["4", "5"],
    paddingBlockStart: type === "popup" ? 0 : ["4", "5"],
    paddingInlineEnd: type === "popup" ? 5 : ["4", "5"],
    paddingInlineStart: type === "popup" ? 5 : ["4", "5"],
    position: "relative",
    "@media screen and (max-height: 32rem)": {
      overflowY: "visible"
    }
  };
};
const StyledDialogBody = /*#__PURE__*/themed("div", process.env.NODE_ENV === "production" ? {
  styleProps: ["type"],
  shouldForwardProp: prop => prop !== "type",
  target: "ew2qmgg0"
} : {
  styleProps: ["type"],
  shouldForwardProp: prop => prop !== "type",
  target: "ew2qmgg0",
  label: "StyledDialogBody"
})(baseStyles, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
const DialogBody = /*#__PURE__*/forwardRef((_ref2, forwardedRef) => {
  let {
    children,
    ...remainingProps
  } = _ref2;
  const {
    type
  } = useDialogContext();
  return jsx(StyledDialogBody, _extends({
    ref: forwardedRef,
    type: type
  }, remainingProps), children);
});
DialogBody.displayName = "DialogBody";

export { DialogBody, baseStyles };
